import { useEffect } from 'react';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#f1f1f1',
    userSelect: 'none',
  },
}));

const LabelComponent = ({ positions, setStateData, stateData, indicator }) => {
  const classes = useStyles();

  useEffect(() => {
    // [CAMBIO L21-L23] Guardas para evitar crash si no llega bien el prop
    if (typeof setStateData !== 'function') return;
    if (!positions?.i) return;

    const kyAux = positions.i;

    // [CAMBIO L28-L43] Update funcional (evita usar stateData stale)
    setStateData(prev => {
      const prevPositions = prev?.positions || [];
      const newPositions = prevPositions.map(elem => {
        if (elem.i === kyAux) {
          return { ...elem, minH: 1, minW: 1 };
        }
        return elem;
      });

      return { ...prev, positions: newPositions };
    });
  }, [indicator, positions?.i, setStateData]); // [CAMBIO L45] deps correctas

  return (
    <Box
      className={classes.container}
      p={2}
      height={'100%'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      fontSize={'18px'}
      textAlign={'center'}
      fontWeight={'bold'}
    >
      {indicator}
    </Box>
  );
};

export default LabelComponent;